import { render, staticRenderFns } from "./ULibraryDocuments.vue?vue&type=template&id=37d382d4&scoped=true&"
import script from "./ULibraryDocuments.vue?vue&type=script&lang=js&"
export * from "./ULibraryDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ULibraryDocuments.vue?vue&type=style&index=0&id=37d382d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d382d4",
  null
  
)

export default component.exports